//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useState, useContext } from 'react';
import AddCircleIcon from '@material-ui/icons/AddCircle';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
// import { LayoutContext } from '../../common/contexts';
import { AppContext, LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { getCompanySizeText, nl2br } from '../../common/textHelper';
import { CONFIRM_DIALOG_MESSAGE_CHANGE_EMP_PROFILE_TO_DRAFT, DASHBOARD_PROFILE_COMPANY_TITLE } from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import { changeEmpProfileToDraft } from '../../common/services/empMyProfileServices';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdTypography from '../../common/elemental/AfitdTypography';
import AfitdConfirmDialog from '../../common/elemental/AfitdConfirmDialog';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import CompanyInfoDialog from './CompanyInfoDialog';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {},
}));

const styles = theme => ({
    companyInfoTitle: {
        fontSize: '20px',
    },
    titleContainer: {
        padding: '0 0 19px 0',
    },
    addCompanyBox: {
        width: '100%',
        height: '130px',
        background: '#FFFFFF',
        border: ' 1px dashed #D5D7DD',
        borderRadius: '4px',
        cursor: 'pointer',
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    addContentItems: {
        marginTop: '53px',
        textAlign: 'center',
        color: 'rgba(17, 30, 20, 0.4)',
    },
    plusIconOutlined: {
        position: 'relative',
        top: '6px',
        color: '#1D8A8B',
    },
    infoTitle: {
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '14px',
    },
    chip: {
        // height: '28px',
        background: '#F0F2F6',
        padding: '5px 10px 5px 10px',
        borderRadius: '4px',
        width: 'fit-content',
        fontWeight: 'bold',
        fontSize: '16px',
        marginBottom: '17px',
    },
    editButton: {
        fontSize: '16px',
        fontWeight: '500',
        color: '#FC821F',
        cursor: 'pointer',
    },
    paraHeadings: {
        marginTop: '40px',
    },
});
//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { editDialogOpen, setEditDialogOpen, props, data, makeProfilePublicDialog, setMakePofilePublicDialog, onConfrimChangeProfileType } = params;
    const { classes, isPublic } = props;

    const defns = {
        openDialogButton: {
            onClick: () => {
                setEditDialogOpen(true);
            },
        },
        addCompanyBox: {
            onClick: () => {
                setEditDialogOpen(true);
            },
        },
        titleText: {
            variant: 'h6',
            clsLightBold: true,
            value: DASHBOARD_PROFILE_COMPANY_TITLE,
        },
        editDialog: {
            open: editDialogOpen,
            onClose: () => {
                setEditDialogOpen(false);
            },
            data,
        },
        editButton: {
            onClick: () => {
                if (isPublic) setMakePofilePublicDialog(true);
                else setEditDialogOpen(true);
            },
        },
        makeProfilePublicDialog: {
            maxWidth: 'sm',
            title: 'Edit Your Profile?',
            onClose: () => setMakePofilePublicDialog(false),
            onConfirm: onConfrimChangeProfileType,
            open: makeProfilePublicDialog,
            message: CONFIRM_DIALOG_MESSAGE_CHANGE_EMP_PROFILE_TO_DRAFT,
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const CompanyInfo = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const { employerId } = useContext(AppContext);
    const { setSnackbarMessage, setSnackbarErrorMessage } = useContext(LayoutContext);
    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const { data, editDialogOpen, setEditDialogOpen } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [data, setData] = useState();
    const [makeProfilePublicDialog, setMakePofilePublicDialog] = useState(false);
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // useEffect(() => {
    //     if (dataProp) {
    //         setData({ ...dataProp });
    //     }
    // }, [dataProp]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const companySizeText = getCompanySizeText(data?.companySize, null);

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const onConfrimChangeProfileType = async () => {
        await changeEmpProfileToDraft({ employerId, setSnackbarMessage, setSnackbarErrorMessage });
    };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        props,
        data,
        editDialogOpen,
        setEditDialogOpen,
        makeProfilePublicDialog,
        setMakePofilePublicDialog,
        onConfrimChangeProfileType,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <div {...defns.header}>
                <div {...defns.titleContainer}>
                    <AfitdTypography {...defns.titleText} />
                </div>
                {/* {data && <span {...defns.editButton}>Edit</span>} */}
            </div>
            {data ? (
                <div>
                    {data?.companyName && (
                        <div>
                            <p {...defns.infoTitle}>Company Name:</p>
                            <div {...defns.chip}>{data?.companyName}</div>
                        </div>
                    )}

                    {data?.industry && (
                        <div>
                            <p {...defns.infoTitle}>Industry:</p>
                            <div {...defns.chip}>{data?.industry}</div>
                        </div>
                    )}

                    {data?.foundedYr && (
                        <div>
                            <p {...defns.infoTitle}>Founded:</p>
                            <div {...defns.chip}>{data?.foundedYr}</div>
                        </div>
                    )}

                    {companySizeText && (
                        <div>
                            <p {...defns.infoTitle}>Company Size:</p>
                            <div {...defns.chip}>{companySizeText}</div>
                        </div>
                    )}

                    {data?.country && (
                        <div>
                            <p {...defns.infoTitle}>Headquarters/Head Office Location:</p>
                            <div {...defns.chip}>
                                {data?.city}, {data?.state}, {data?.country}
                            </div>
                        </div>
                    )}
                    {data?.bio && (
                        <div>
                            <h4 {...defns.paraHeadings}>Company Bio:</h4>
                            <p>{nl2br(data?.bio)}</p>
                        </div>
                    )}

                    {data?.benefit && (
                        <div>
                            <h4 {...defns.paraHeadings}>Benefits Summary:</h4>
                            <p>{nl2br(data?.benefit)}</p>
                        </div>
                    )}
                </div>
            ) : (
                <div>
                    <div {...defns.addCompanyBox}>
                        <div {...defns.addContentItems}>
                            <AddCircleIcon {...defns.plusIconOutlined} />
                            <span>Add Company Info</span>
                        </div>
                    </div>
                </div>
            )}

            {editDialogOpen && <CompanyInfoDialog {...defns.editDialog} />}
            <AfitdConfirmDialog {...defns.makeProfilePublicDialog} />
        </div>
    );
};

export default withStyles(styles)(CompanyInfo);
